// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3MxhC","colMin":"styles_colMin__3zMQf","colCheckbox":"styles_colCheckbox__yQCnh"};